<template>
  <v-container>
    <v-row class="text-right">
      <GoBackButton />
      <v-col>
        <h2 class="mt-4">{{ this.$route.params.organization }}</h2>
      </v-col>
    </v-row>

    <v-divider class="ma-4"></v-divider>

    <v-col class="text-right">
      <AddForm :data="'Provider User'" @add="addUser($event)" />
    </v-col>

    <v-container class="d-block">
      <v-card>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            clearable
            clear-icon="mdi-close-circle-outline"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="providers"
          :loading="loading"
          :search="search"
          class="elevation-1"
          loading-text="Loading... Please wait"
        >
          <template v-slot:[`item.active`]="{ item }">
            <v-icon v-if="item.active" color="green" title="enabled"
              >mdi-check-circle-outline</v-icon
            >
            <v-icon v-else color="primary" title="disabled"
              >mdi-close-circle-outline</v-icon
            >
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon
              dark
              class="mx-2"
              color="primary"
              name="disable"
              title="disable"
              v-if="item.active"
              @click="disableUser(item)"
              >mdi-account-multiple-remove-outline</v-icon
            >
            <v-icon
              dark
              class="mx-2"
              color="green"
              name="enable"
              title="enable"
              v-else
              @click="enableUser(item)"
              >mdi-account-multiple-check-outline</v-icon
            >
            <delete-with-confirm
              :id="item.email"
              @deleted="deleteUser($event)"
            />
          </template>
          <template v-slot:no-data>
            <span color="primary">No data to show you</span>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <Confirm
      :dialog.sync="dialog"
      :message.sync="msg"
      @confirm="sendConfirm()"
    />
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import DeleteWithConfirm from "@/components/DeleteWithConfirm.vue";
import Confirm from "@/components/Confirm.vue";
import AddForm from "@/components/AddForm.vue";
import GoBackButton from "@/components/GoBackButton.vue";

export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Email", value: "email" },
      { text: "Name", value: "name" },
      { text: "Surname", value: "surname" },
      { text: "Phone", value: "phone" },
      { text: "Active", align: "center", value: "active" },
      { text: "Actions", align: "center", value: "action", sortable: false },
    ],
    loading: false,
    user: {},
    dialog: false,
    msg: "",
  }),
  components: {
    DeleteWithConfirm,
    Confirm,
    GoBackButton,
    AddForm
  },
  computed: {
    ...mapState({
      providers: (state) => state.providers,
      selectedOrganization: (state) => state.selectedOrganization,
    }),
  },
  created: async function () {
    this.loading = true;
    if (!this.selectedOrganization) {
      this.$router.push("/admin-providers");
    } else {
      await this.$store.dispatch("setUsers", {
        role: "Provider",
        organization: this.selectedOrganization,
      });
    }
    this.loading = false;
  },
  methods: {
    addUser: async function (user) {
      this.loading = true;
      const _user = {
        username: user.email,
        name: user.firstname,
        surname: user.lastname,
        role: "Provider",
        phone: user.phone,
        organization: this.selectedOrganization,
        sftp: false
      };
      await this.$store.dispatch("putUsers", _user);
      this.loading = false;
    },
    deleteUser: async function (user) {
      this.loading = true;
      await this.$store.dispatch("removeUsers", {
        role: "Provider",
        key: user,
      });
      this.loading = false;
    },
    disableUser(item) {
      this.user.email = item.email;
      this.user.action = "disable";
      this.msg = "This action will disable this user";
      this.dialog = true;
    },
    enableUser(item) {
      this.user.email = item.email;
      this.user.action = "enable";
      this.msg = "This action will enable this user";
      this.dialog = true;
    },
    resetPassword(item) {
      this.user.email = item.email;
      this.user.action = "reset_password";
      this.msg = "This action will reset password of this user";
      this.dialog = true;
    },
    sendConfirm: async function () {
      this.loading = true;
      switch (true) {
        case this.user.action === "disable":
          await this.$store.dispatch("disableUsers", { email: this.user.email });
          await this.$store.dispatch("setUsers", {
            role: "Provider",
            organization: this.selectedOrganization,
          });
          break;
        case this.user.action === "enable":
          await this.$store.dispatch("enableUsers", { email: this.user.email });
          await this.$store.dispatch("setUsers", {
            role: "Provider",
            organization: this.selectedOrganization,
          });
          break;
        default:
          await this.$store.dispatch("resetPasswordAction", {
            key: this.user.email,
          });
          break;
      }
      this.loading = false;
    },
  },
};
</script>